import { FontStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/FontStyle";
import { LoaderFontStyle } from "@lib/titan2/dist/game/view/style/CommonFontStyle";
/**
 * GameFontStyle.ts
 */
export class GameFontStyle extends FontStyle {
}
GameFontStyle.STANDARD_SPINS_REMAINING_LABEL = "GameFontStyle.SPINS_REMAINING_LABEL";
GameFontStyle.PURCHASE_SPINS_REMAINING_LABEL = "GameFontStyle.PURCHASE_SPINS_REMAINING_LABEL";
GameFontStyle.TOTAL_WIN_TITLE = "GameFontStyle.TOTAL_WIN_TITLE";
GameFontStyle.TOTAL_WIN_VALUE = "GameFontStyle.TOTAL_WIN_VALUE";
GameFontStyle.COLLECT_BUTTON_VALUE_TEXT = "GameFontStyle.COLLECT_BUTTON_VALUE_TEXT";
GameFontStyle.AVAILABLE_WIN_LABEL_MEDIUM = "GameFontStyle.AVAILABLE_WIN_LABEL_MEDIUM";
GameFontStyle.WIN_ANIMATION_COUNTER = "GameFontStyle.WIN_ANIMATION_COUNTER";
GameFontStyle.WIN_ANIMATION_TITLE_0 = "GameFontStyle.WIN_ANIMATION_TITLE_0";
GameFontStyle.WIN_ANIMATION_TITLE_1 = "GameFontStyle.WIN_ANIMATION_TITLE_1";
GameFontStyle.WIN_ANIMATION_TITLE_2 = "GameFontStyle.WIN_ANIMATION_TITLE_2";
GameFontStyle.WIN_ANIMATION_TITLE_3 = "GameFontStyle.WIN_ANIMATION_TITLE_3";
GameFontStyle.GAME_SUMMARY_CELL_VALUE = "GameFontStyle.GAME_SUMMARY_CELL_VALUE";
GameFontStyle.GAME_SUMMARY_TOTAL_WIN_TITLE = "GameFontStyle.GAME_SUMMARY_TOTAL_WIN_TITLE";
GameFontStyle.REEL_SYMBOL_HIGHLIGHT = "GameFontStyle.REEL_SYMBOL_HIGHLIGHT";
GameFontStyle.TICKET_SYMBOL_SUPER_DAB_HIGHLIGHT = "GameFontStyle.TICKET_SYMBOL_SUPER_DAB_HIGHLIGHT";
GameFontStyle.PLAYER_CONTROL_BUTTONS = "GameFontStyle.PLAYER_CONTROL_BUTTONS";
GameFontStyle.SCATTER_PANEL_COUNT_MAX = "GameFontStyle.SCATTER_PANEL_COUNT_MAX";
GameFontStyle.SCATTER_PANEL_COUNT_MID = "GameFontStyle.SCATTER_PANEL_COUNT_MID";
GameFontStyle.SCATTER_PANEL_COUNT_MIN = "GameFontStyle.SCATTER_PANEL_COUNT_MIN";
GameFontStyle.SCATTER_PANEL_TITLE = "GameFontStyle.SCATTER_PANEL_TITLE";
GameFontStyle.SCATTER_PANEL_FIELD = "GameFontStyle.SCATTER_PANEL_FIELD";
GameFontStyle.GAME_MESSAGES = "GameFontStyle.GAME_MESSAGES";
GameFontStyle.WIN_LINE_AMOUNT = "GameFontStyle.WIN_LINE_AMOUNT";
GameFontStyle.WIN_LINE_MULTIPLIER = "GameFontStyle.WIN_LINE_MULTIPLIER";
GameFontStyle.SCATTER_PICK_INSTRUCTIONS = "GameFontStyle.SCATTER_PICK_INSTRUCTIONS";
GameFontStyle.SCATTER_PICK_RIBBON_LOW = "GameFontStyle.SCATTER_PICK_RIBBON_LOW";
GameFontStyle.SCATTER_PICK_RIBBON_MEDIUM = "GameFontStyle.SCATTER_PICK_RIBBON_MEDIUM";
GameFontStyle.SCATTER_PICK_RIBBON_HIGH = "GameFontStyle.SCATTER_PICK_RIBBON_HIGH";
GameFontStyle.SCATTER_PICK_LABEL_MINI = "GameFontStyle.SCATTER_PICK_LABEL_MINI";
GameFontStyle.SCATTER_PICK_LABEL_MINOR = "GameFontStyle.SCATTER_PICK_LABEL_MINOR";
GameFontStyle.SCATTER_PICK_LABEL_MAJOR = "GameFontStyle.SCATTER_PICK_LABEL_MAJOR";
GameFontStyle.SCATTER_PICK_MULTIPLIER = "GameFontStyle.SCATTER_PICK_MULTIPLIER";
GameFontStyle.DIALOG_BUTTON_BIG = "GameFontStyle.DIALOG_BUTTON_BIG";
GameFontStyle.DIALOG_PROMPT_BODY = "GameFontStyle.DIALOG_PROMPT_BODY";
GameFontStyle.DIALOG_PROMPT_TITLE = "GameFontStyle.DIALOG_PROMPT_TITLE";
GameFontStyle.MESSAGE_DIALOG_TITLE = "GameFontStyle.MESSAGE_DIALOG_TITLE";
GameFontStyle.MESSAGE_DIALOG_BODY = "GameFontStyle.MESSAGE_DIALOG_BODY";
export class GameLoaderFontStyle extends LoaderFontStyle {
}
GameLoaderFontStyle.FOOTER = "GameLoaderFontStyle.FOOTER";
GameLoaderFontStyle.COPYRIGHT_ALT = "GameLoaderFontStyle.COPYRIGHT_ALT";
GameLoaderFontStyle.VERSION_ALT = "GameLoaderFontStyle.VERSION_ALT";
GameLoaderFontStyle.INFO_FIELD_SLINGO = "GameLoaderFontStyle.INFO_FIELD_SLINGO";
//# sourceMappingURL=GameFontStyle.js.map